import { apiRequest } from '../apiHelper';
import ROUTES from './index.constant';

export type SortBy =
    | 'roleName'
    | 'description'
    | 'type'
    | 'usersCount'
    | 'updatedDate';

export type SortOrder = 'ASC' | 'DESC';

export const getTenantRoles = async (
    tenantId: string | number,
    query?: {
        dropdown?: boolean;
        allTenants?: boolean;
        role?: string;
        sortBy?: SortBy | string;
        sortOrder?: SortOrder;
        page?: number;
        limit?: number;
    }
) => {
    const searchParams = new URLSearchParams();

    if (query?.dropdown !== undefined) searchParams.set('dropdown', String(query.dropdown));
    if (query?.allTenants !== undefined) searchParams.set('allTenants', String(query.allTenants));
    if (query?.role) searchParams.set('roleName', query.role);
    if (query?.sortBy) searchParams.set('sortBy',query.sortBy);
    if (query?.sortOrder) searchParams.set('sortOrder', query.sortOrder);
    if (query?.page !== undefined) searchParams.set('page', String(query.page));
    if (query?.limit !== undefined) searchParams.set('limit', String(query.limit));

    const queryString = searchParams.toString();
    const url = `${ROUTES.ALL_ROLES}/${tenantId}${queryString ? `?${queryString}` : ''}`;

    return apiRequest(url, {
        method: 'GET',
    });
};